import { Link } from "react-router-dom";
import {
  BASE_URL,
  HOME_URL_LOCAL,
  SECTION_USER_URL_LOCAL,
  SHOPPINGCART_URL_LOCAL,
} from "../../utility/BaseUrl";
import { useEffect, useState } from "react";
import { setFullNameCookie, setImageUrlCookie } from "../../utility/Cookies";
import Swal from "sweetalert2";
import { UpdateProfileService } from "../../services/MainScreen";

export default function Profile({ user, setData }) {
  const [formData, setFormData] = useState({
    name: user.name,
    family: user.family,
    image: user.image,
  });
  const [loading, setLoading] = useState(false);

  if (!user) return;

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLoading(true);
      setFormData({
        ...formData,
        image: file,
      });
      setTimeout(() => setLoading(false), 1000);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await UpdateProfileService(
        formData.family,
        formData.name,
        typeof formData.image !== "string" ? formData.image : null
      );
      if (response.status === 200) {
        const { name, family, image } = response.result;
        const full_name = name + " " + family;

        setData((prevData) => ({
          ...prevData,
          user: {
            ...user,
            name: name,
            family: family,
            image: image,
          },
        }));

        setFullNameCookie(full_name);
        setImageUrlCookie(formData.image);

        Swal.fire({
          icon: "success",
          title: "موفق",
          text: response.message,
          confirmButtonText: "باشه",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "خطا",
          text: "مشکلی در به‌روزرسانی پروفایل شما وجود دارد!",
          confirmButtonText: "باشه",
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <form name="form" onSubmit={handleSubmit}>
      <div className="pagetitle">
        <ol className="breadcrumb">
          <li>
            <Link to={HOME_URL_LOCAL}> خانه </Link>
          </li>
          <li className="active font-weight-bold">ویرایش مشخصات</li>
        </ol>
      </div>
      <div className="content-wrapper no-sidebar">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12"></div>
            <div className="col-sm-12">
              <div className="w-restricted-lg">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label> نام </label>
                      <div className="input-group">
                        <span className="input-group-addon d-flex justify-content-center align-items-center">
                          <i className="fa fa-pencil fa-fw" />
                        </span>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          className="form-control tempDisabled"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label> نام خانوادگی </label>
                      <div className="input-group">
                        <span className="input-group-addon d-flex justify-content-center align-items-center">
                          <i className="fa fa-pencil fa-fw" />
                        </span>
                        <input
                          type="text"
                          name="family"
                          id="family"
                          className="form-control tempDisabled"
                          value={formData.family}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="margin-y-lg" />
              <div className="w-restricted-lg">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group image-uploader">
                      <label className="margin-clear">تصویر آواتار</label>
                      <p className="help-block">
                        برای آپلود و یا تغییر، بر روی تصویر زیر کلیک کنید.
                      </p>
                      <label className="image-uploader-selector">
                        {formData.image ? (
                          typeof formData.image === "string" ? (
                            <img
                              className="img-responsive"
                              src={BASE_URL + formData.image}
                              alt="Preview"
                              style={{ width: "150px" }}
                            />
                          ) : (
                            <img
                              className="img-responsive"
                              src={URL.createObjectURL(formData.image)}
                              alt="Preview"
                              style={{ width: "150px" }}
                            />
                          )
                        ) : (
                          <span className="img-responsive"> انتخاب عکس </span>
                        )}

                        {loading ? (
                          <span className="image-uploader-loading">
                            <i className="fa fa-3x fa-refresh fa-spin" />
                          </span>
                        ) : null}

                        <input
                          type="file"
                          accept="image/*"
                          className="tempDisabled"
                          name="image"
                          onChange={handleImageChange}
                        />
                      </label>

                      {formData.image ? (
                        <div className="image-uploadr-remover">
                          <button
                            type="button"
                            className="btn btn-xs btn-danger tempDisabled"
                            onClick={() => {
                              setFormData({
                                ...formData,
                                image: null,
                              });
                            }}
                          >
                            <i className="fa fa-trash" />
                            حذف تصویر
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <hr className="margin-bottom-xl margin-top-lg" />
            </div>
            <div className="col-sm-12">
              <button
                type="submit"
                className="btn btn-success btn-lg tempDisabled"
              >
                ذخیره تغییرات
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
